import React from 'react';
import PageTemplatePlanoAnual from '../../templates/PageTemplatePlanoAnual';
import GridColumns from 'pages/ebooks/components/templates/GridColumns';
import StyledGlobal from '../../../../PlanoAnual2025.styled';
import { fetchStorageFile } from 'hooks/StoreFiles';
import { ConfigProvider, Image, Table } from 'antd';
import Colors from 'enums/Colors';
import { ColumnsType } from 'antd/es/table';
import Quote from 'pages/ebooks/components/Quote';
import CardQRcodeVideosPlanoAnual from '../../components/CardQRcodeVideosPlanoAnual';
import ResponsiveGrid from 'pages/ebooks/components/templates/ResponsiveGrid';

interface DataType {
    key: string;
    name: string;
    solucoes: string;
}

const dataSource: DataType[] = [
    {
        key: '1',
        name: 'Gestão Nota 10',
        solucoes: `
        O programa é voltado para o fortalecimento das lideranças educacionais e escolares,
        apoiando a atuação de diretores tecnicamente qualificados e preparados para garantir o
        alcance das metas de aprendizagem e a melhoria dos indicadores educacionais.
        `,
    },
    {
        key: '2',
        name: 'Circuito 360',
        solucoes: `
        O Programa tem como objetivo apoiar as secretarias de educação na
        formulação e gestão de políticas educacionais para os <strong>Anos Iniciais do
        Ensino Fundamental</strong>, com foco na perspectiva de educação integral.
        `,
    },
    {
        key: '3',
        name: 'Se Liga',
        solucoes: `
            O programa é voltado para a alfabetização de estudantes com distorção
            idade-série matriculados do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
    },
    {
        key: '4',
        name: 'Acelera Brasil',
        solucoes: `
            O programa tem como objetivo reduzir a distorção idade-série por meio da
            aceleração do fluxo escolar de estudantes do <strong>3º ao 5º ano do Ensino Fundamental.</strong>
        `,
    },
    {
        key: '5',
        name: 'Fórmula da Vitória',
        solucoes: `
        O programa tem como objetivo qualificar a aprendizagem em Língua Portuguesa
        de estudantes dos <strong>Anos Finais do Ensino Fundamental</strong>, contribuindo para
        reverter quadros de reprovação e exclusão no ambiente escolar.
        `,
    },
];

const columns: ColumnsType<DataType> = [
    {
        title: 'SOLUÇÃO EDUCACIONAL ',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
        render: (text: string) => <span style={{ fontWeight: 'bold' }}>{text}</span>,
    },
    {
        title: 'DESCRIÇÃO',
        dataIndex: 'solucoes',
        key: 'solucoes',
        align: 'center',
        render: (text: string) => (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: Colors.White,
                    padding: '20px',
                    borderRadius: 8,
                }}
            >
                <span style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        ),
    },
    // {
    //     title: 'CRIANÇAS E JOVENS ATENDIDOS',
    //     dataIndex: 'estudantes',
    //     key: 'estudantes',
    //     align: 'center',
    //     render: (text: string) => (
    //         <div
    //             style={{
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //                 backgroundColor: Colors.Yellow,
    //                 borderRadius: 8,
    //             }}
    //         >
    //             <span
    //                 style={{
    //                     fontWeight: 'bold',
    //                     color: Colors.White,
    //                     fontSize: '22px',
    //                     alignSelf: 'center',
    //                     justifySelf: 'center',
    //                 }}
    //             >
    //                 {text}
    //             </span>
    //         </div>
    //     ),
    // },
];

interface PageThreeFivePlanoAnualProps {}

const PageThreeFivePlanoAnual: React.FC<PageThreeFivePlanoAnualProps> = () => {
    return (
        <>
            <PageTemplatePlanoAnual numberPage={51} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title blue fontSize="32px">
                    3.5 NOVA IGUAÇU
                </StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Localizada na Baixada Fluminense, <strong>Nova Iguaçu</strong> é um município relevante da Região Metropolitana do
                            Rio de Janeiro, com mais de <strong>785 mil habitantes</strong> e um dos centros comerciais mais importantes do
                            estado. Sua economia é diversificada, com forte presença nos setores de comércio e serviços.
                        </p>
                        <p>
                            Apesar de ser um importante pólo regional, o município enfrenta desafios socioeconômicos típicos das regiões
                            metropolitanas, incluindo questões ligadas à desigualdade e à informalidade no mercado de trabalho.
                        </p>
                        <p>
                            Com o objetivo de <strong>acelerar a qualidade da educação pública</strong> e combater as desigualdades, o município
                            firmou uma parceria com o Instituto Ayrton Senna para implementar o{' '}
                            <strong>Plano Anual Instituto Ayrton Senna.</strong> A iniciativa posiciona Nova Iguaçu como protagonista na busca
                            por um ensino mais eficiente e transformador, focando em quatro eixos principais: alfabetização, combate ao atraso
                            escolar, gestão escolar e melhoria da aprendizagem.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <h2>3.5.1 A EDUCAÇÃO NO MUNICÍPIO</h2>
                        <p>
                            O município de Nova Iguaçu apresenta resultados de alfabetização inferiores ao estado do Rio de Janeiro e ao Brasil,
                            indicando que os desafios educacionais estão presentes já nas séries iniciais. Além disso, os indicadores
                            educacionais para os anos seguintes da educação básica são preocupantes, com altas taxas de distorção idade-série,
                            reprovação e baixos níveis de aprendizado.
                        </p>
                        <StyledGlobal.TitleYellow>ACESSO</StyledGlobal.TitleYellow>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ width: '100%' }}
                                src={fetchStorageFile('anexo_storage_files_10428081808974482049.png_2025-11-21-1763728759933.png')}
                                alt={`
                                    Quadro comparativo dos anos iniciais e finais do Ensino Fundamental, com ícones de escola, professor e matrícula. Nos anos iniciais: 122 escolas, 1.164 professores e 36.866 matrículas. 
                                    Nos anos finais: 49 escolas, 835 professores e 13.260 matrículas. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                            <p style={{ fontSize: '14px' }}>Fonte: MEC/Inep - Censo Escolar (2024). Rede Municipal.</p>
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={52} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 300px 1fr',
                        notebook: '1fr 300px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>ALFABETIZAÇÃO</StyledGlobal.TitleYellow>
                        <p>
                            O percentual de estudantes alfabetizados(as) no município subiu marginalmente de 2023 para 2024, alcançando 33,4%.
                            Esse resultado é <strong>inferior ao observado na média do estado do Rio de Janeiro e na média nacional.</strong>
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ width: '100%' }}
                                src={fetchStorageFile('anexo_storage_files_7268883205848466171.png_2025-11-21-1763729641808.png')}
                                alt={`
                                    Gráfico de barras comparando a taxa de alfabetização em 2023 e 2024 para Nova Iguaçu, Rio de Janeiro e o Brasil. 
                                    Nova Iguaçu: 33,2% em 2023 e 33,4% em 2024. 
                                    Rio de Janeiro: 52,1% em 2023 e 55,3% em 2024. 
                                    Brasil: 55,9% em 2023 e 59,2% em 2024. 
                                    As barras de 2023 aparecem em azul escuro e as de 2024 em azul claro. Setas sinalizam aumento nos três recortes.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            style={{ width: '100%', height: '720px', objectFit: 'cover', objectPosition: '60% 50%' }}
                            src={fetchStorageFile('anexo_storage_files_5369656271759834001.webp_2025-11-21-1763729731358.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>DISTORÇÃO IDADE-SÉRIE</StyledGlobal.TitleYellow>
                        <p>
                            A distorção idade-série caiu menos no município do que na média do Rio de Janeiro e do Brasil no intervalo de dez
                            anos. Em 2024,{' '}
                            <strong>o percentual de estudantes atrasados(as) no município era mais que o dobro da média nacional</strong> nos
                            anos iniciais do Ensino Fundamental e quase 12 pontos percentuais a mais nos anos finais.
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ width: '100%' }}
                                src={fetchStorageFile('anexo_storage_files_7808816062896221569.png_2025-11-21-1763729916696.png')}
                                alt={`
                                    Gráfico de barras comparando a distorção idade-série em 2024 para anos iniciais e anos finais nos recortes Nova Iguaçu, Rio de Janeiro e Brasil. 
                                    Anos iniciais: Nova Iguaçu 20,9%; Rio de Janeiro 15,1%; Brasil 8%. 
                                    Anos finais: Nova Iguaçu 32,8%; Rio de Janeiro 24,1%; Brasil 20,9%. 
                                    As barras usam três cores: azul claro para Nova Iguaçu, azul escuro para RJ e amarelo para Brasil.” 
                                    
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fontes: MEC - Indicador Criança Alfabetizada. MEC/Inep - Censo Escolar.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={53} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.TitleYellow>
                                    APROVAÇÃO,
                                    <br /> REPROVAÇÃO E ABANDONO
                                </StyledGlobal.TitleYellow>
                                <p>
                                    Em dez anos as taxas de aprovação aumentaram 7,1 pontos percentuais nos anos iniciais do Ensino Fundamental e
                                    10,9 pontos percentuais nos anos finais, ritmo semelhante à média do Rio de Janeiro e relativamente próximo à
                                    média nacional. Apesar desse aumento,{' '}
                                    <strong>
                                        os percentuais de estudantes aprovados no município permanecem em patamar abaixo do estado e do país,
                                    </strong>{' '}
                                    em grande medida pelas <strong>altas taxas de reprovação.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <StyledGlobal.CardWhite2>
                                    <Image
                                        style={{ width: '100%' }}
                                        src={fetchStorageFile('anexo_storage_files_10347324095218409849.png_2025-11-21-1763730809610.png')}
                                        alt={`
                                            Gráfico de barras empilhadas mostrando taxas de aprovação, reprovação e abandono em 2024, comparando Nova Iguaçu, Rio de Janeiro e Brasil. Nos anos iniciais, aprovação: Nova Iguaçu 92,2%, Rio de Janeiro 93,9%, Brasil 96,9%. 
                                            Reprovação: Nova Iguaçu 7,1%, Rio de Janeiro 5,7%, Brasil 2,8%. 
                                            Abandono: Nova Iguaçu 0,7%, Rio de Janeiro 0,4%, Brasil 0,3%. 
                                            Nos anos finais, aprovação: Nova Iguaçu 87,9%, Rio de Janeiro 91,5%, Brasil 92%.  
                                            Reprovação: Nova Iguaçu 11,1%, Rio de Janeiro 7,7%, Brasil 6,6%. 
                                            Abandono: Nova Iguaçu 1%, Rio de Janeiro 0,8%, Brasil 1,4%. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.CardWhite2>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Image
                            height={380}
                            style={{ width: '100%', objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_6382341232577920065.webp_2025-11-21-1763730875132.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>

                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.TitleYellow>APRENDIZADO ADEQUADO</StyledGlobal.TitleYellow>
                        <p>
                            Os percentuais de estudantes com aprendizado adequado em Língua Portuguesa no 5º e 9º ano do Ensino Fundamental em
                            Nova Iguaçu são <strong>bem inferiores à média do estado e do país.</strong> No 5º ano a diferença alcança 15 pontos
                            percentuais.
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ width: '100%' }}
                                src={fetchStorageFile('anexo_storage_files_17647449590587590854.png_2025-11-21-1763731039277.png')}
                                alt={`
                                    Conjunto de ícones de crianças representando a proporção de aprendizado adequado em Língua Portuguesa no 5º ano e 9º ano do Ensino Fundamental. 
                                    5º ano: Nova Iguaçu 38,6%, Rio de Janeiro 53,4%, Brasil 54,2%. 
                                    9º ano: Nova Iguaçu 28,5%, Rio de Janeiro 38,3%, Brasil 33,6%. 
                                    Uma parte dos ícones são pintados de azul de acordo com o percentual de cada território, para indicar os estudantes com nível adequado; o restante dos ícones está em cinza. 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>

                <p style={{ fontSize: '14px' }}>Fonte: MEC/Inep - Censo Escolar. MEC/Inep - SAEB. Rede Municipal.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={54} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '480px 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.Title style={{ color: Colors.Blue }}>
                            3.5.2 APRESENTAÇÃO DO <br /> PLANO ANUAL EM NOVA IGUAÇU
                        </StyledGlobal.Title>
                        <p>
                            No âmbito do Plano Anual Instituto Ayrton Senna, o município de Nova Iguaçu implementou cinco soluções educacionais,
                            para ajudar a rede de ensino a lidar com os desafios de alfabetização, atraso escolar, defasagem de aprendizagens e
                            gestão escolar.
                        </p>

                        <StyledGlobal.CardBlue
                            style={{ maxWidth: '240px', marginTop: '80px', padding: '40px' }}
                            role="img"
                            aria-label="Quadro informativo apresentando o dado: mais de 50 mil professores e alunos da rede pública de ensino"
                        >
                            <div className="metrica">
                                <span> +50 mil </span> <p>professores e alunos da rede pública de ensino</p>
                            </div>
                        </StyledGlobal.CardBlue>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.TableWrapper>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorTextHeading: '#0e60e8',
                                    colorBgBase: '#eae8e6',
                                },
                            }}
                            table={{
                                style: {
                                    background: 'none',
                                },
                            }}
                        >
                            <Table pagination={false} dataSource={dataSource} columns={columns} scroll={{ x: 900 }} style={{ minWidth: 900 }} />
                        </ConfigProvider>
                    </StyledGlobal.TableWrapper>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>
                    Fontes: MEC/Inep - Censo Escolar (2024). Rede Municipal. Sistema de Monitoramento Instituto Ayrton Senna.
                </p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={55} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.Title style={{ color: Colors.Blue }}>3.5.3 RESULTADOS</StyledGlobal.Title>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr 1fr',
                        tablet: '1fr 1fr',
                        mobile: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            O Instituto Ayrton Senna tem se consolidado como parceiro-chave da Secretaria de Educação de Nova Iguaçu na promoção
                            de uma educação de qualidade. Os cinco programas iniciados em 2025 já apresentam resultados tangíveis na rotina das
                            escolas, ampliando o horizonte de futuro das crianças.
                        </p>
                        <p>
                            Em 2025, no escopo dessa parceria, foram realizados{' '}
                            <strong>
                                16 cursos presenciais com técnicos(as) da secretaria de educação, diretores(as), coordenadores(as)
                                pedagógicos(as) e professores(as),
                            </strong>{' '}
                            a fim de preparálos(as) para implementar os diferentes programas educacionais no município: Gestão Nota 10, Fórmula
                            da Vitória, Circuito 360, Se Liga e Acelera Brasil. Além disso, foram <strong>realizados 26 cursos virtuais,</strong>{' '}
                            para que os(as) educadores(as) tivessem acesso contínuo às formações.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Essas formações foram avaliadas positivamente, com nível médio de <br />
                            <strong style={{ fontSize: '24px' }}>satisfação 65%,</strong>
                            <p>compreendido como zona de qualidade.</p>
                        </p>
                        <p>
                            Além das formações sobre os programas educacionais, os(as) profissionais de educação contaram com apoio contínuo da
                            equipe do Instituto Ayrton Senna ao longo do ano.
                        </p>
                        <StyledGlobal.CardGray
                            style={{ maxWidth: '250px' }}
                            role="img"
                            aria-label="Foram realizadas 8 oficinas presenciais e 10 oficinas virtuais"
                        >
                            <span> Foram realizadas</span> <strong>8 oficinas presenciais e 10 oficinas virtuais</strong>
                        </StyledGlobal.CardGray>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Quote
                            text={`
                            O evento formativo
                            contribuiu com minha
                            formação à medida que
                            ajudou-me a refletir
                            e a rever algumas
                            atitudes na prática de
                            gestora da escola. Ter
                            tempo para formação
                            é fundamental e por
                            vezes o diretor cuida e
                            propõe ao grupo, sem
                            ter tempo para formarse também. Gratidão!"
                            <br/>
                            <br/>
                            Depoimento de um(a)
                            participante dos cursos
                            presenciais
                            
                            `}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            height={720}
                            width={'100%'}
                            style={{ objectFit: 'cover', objectPosition: '20% 50%' }}
                            src={fetchStorageFile('anexo_storage_files_7248601770789557627.webp_2025-11-21-1763731891833.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={56} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Em Nova Iguaçu, o acompanhamento dos resultados educacionais se fortaleceu com a{' '}
                                    <strong>criação e institucionalização de um Comitê Gestor,</strong> que organiza a governança e transforma a
                                    análise de dados em prática contínua, envolvendo todos os agentes na apropriação, responsabilização e busca
                                    de soluções para os desafios identificados. Esse comitê reúne o Secretário de Educação, equipes da Secretaria
                                    responsáveis pelos programas educacionais e especialistas do Instituto Ayrton Senna.
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Para que os dados orientem, de fato, as decisões da rede, é essencial dispor de informações que reflitam o
                                    cotidiano da sala de aula. Por isso, cada programa do município definiu com clareza quais dados coletar e
                                    quem deve acompanhálos. Além disso, uma <strong>plataforma de monitoramento foi disponibilizada</strong> para
                                    concentrar e organizar essas informações, permitindo{' '}
                                    <strong>decisões ágeis e direcionadas ao desenvolvimento integral dos estudantes.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <Image
                            height={400}
                            style={{ objectFit: 'cover' }}
                            src={fetchStorageFile('anexo_storage_files_5144481795158631727.webp_2025-11-21-1763732479024.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.CardWhite2>
                            <h2 style={{ fontSize: '14px' }}>FAIXA ETÁRIA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_3616329631641153442.png_2025-11-21-1763732628769.png')}
                                        alt={`
                                            Gráfico de pizza mostrando a distribuição por idade dos estudantes do Acelera Brasil: 10 anos (12,8%), 
                                            11 anos (21,6%), 12 anos (32,6%), 13 anos (19,4%) e 14 anos (10,3%), 15 anos ou mais (3,3%). Cada fatia identifica a porcentagem por faixa etária. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_16920781666672732340.png_2025-11-21-1763732657116.png')}
                                        alt={`
                                            Gráfico de pizza representando distribuição de idades no programa Se Liga: 10 anos (20,9%), 11 anos (33,8%), 12 anos (25,7%), 
                                            13 anos (11,8%), 14 anos (4,8%) e 15 anos ou mais (3%). Cada fatia identifica a porcentagem por faixa etária. 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                            </ResponsiveGrid>
                            <p>
                                As turmas do Acelera Brasil no município são relativamente bem distribuídas entre alunos(as) de idades entre 10 a
                                14 anos, além de alguns estudantes mais velhos(as), com 15 anos, idade esperada para a 1ª série do Ensino Médio.
                            </p>
                            <br />
                            <p>
                                As turmas do Se Liga, apesar de também contarem com estudantes de toda essa faixa de idade, apresentam uma média
                                de idade relativamente menor, com mais da metade dos(as) estudantes com 11 anos ou menos.{' '}
                            </p>
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={57} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Esses(as) estudantes já demonstram{' '}
                                    <strong>
                                        resultados em termos de aprendizagem. Quase 60% dos(as) alunos(as) das turmas do Se Liga estavam no nível
                                        mais baixo
                                    </strong>{' '}
                                    de Língua Portuguesa, equivalente à Educação Infantil, em maio de 2025. Quatro meses depois,{' '}
                                    <strong>o percentual caiu para 36%.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    No Acelera Brasil, os primeiros efeitos dos programas em termos de recuperação de aprendizagem também estão
                                    aparecendo. Em apenas quatro meses{' '}
                                    <strong>
                                        o percentual de estudantes que leem com fluência aumentou mais de 10 pontos percentuais. Na capacidade de
                                        escrita o avanço é ainda maior: 20 pontos de diferença
                                    </strong>{' '}
                                    no percentual de estudantes que escrevem palavras com sílabas complexas ortograficamente.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <StyledGlobal.CardWhite2>
                            <h2 style={{ fontSize: '14px' }}>NÍVEL EM LÍNGUA PORTUGUESA</h2>
                            <ResponsiveGrid
                                templates={{
                                    desktop: '1fr 1fr',
                                    tablet: '1fr',
                                }}
                                styles={{ margin: 0, gap: '40px' }}
                            >
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_16229794969102754724.png_2025-11-21-1763732955651.png')}
                                        alt={`
                                            Dois grupos de ícones em formato de círculo, com preenchimento em amarelo representando o percentual de estudantes do Se Liga no nível mais baixo em língua portuguesa. 
                                            Texto que acompanha o primeiro grupo diz: ‘Em maio, 60% dos estudantes do Se Liga estavam no nível mais baixo de Língua Portuguesa’ 
                                            Texto que acompanha o segundo grupo diz: ‘Quatro meses depois, o percentual caiu para 36%, ou seja, houve evolução de nível’ 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                                <StyledGlobal.ContentColumn>
                                    <Image
                                        src={fetchStorageFile('anexo_storage_files_15108313460086361066.png_2025-11-21-1763732970864.png')}
                                        alt={`
                                            Dois grupos de ícones em formato de círculo, com preenchimento em azul representando o percentual de estudantes do Acelera Brasil que escrevem palavras com sílabas complexas.  
                                            Texto que acompanha o primeiro grupo diz: ‘No início do programa, apenas 38% escreviam palavras com sílabas complexas’ 
                                            Texto que acompanha o segundo grupo diz: ‘Em setembro, 58% da turma já tinha conquistado essa competência’ 
                                            `}
                                        preview={{
                                            style: {
                                                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                            },
                                        }}
                                    />
                                </StyledGlobal.ContentColumn>
                            </ResponsiveGrid>
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <ResponsiveGrid
                            templates={{
                                desktop: '1fr 1fr',
                                tablet: '1fr',
                            }}
                            styles={{ margin: 0, gap: '40px' }}
                        >
                            <StyledGlobal.ContentColumn>
                                <p>
                                    Os resultados evidenciam que os programas são{' '}
                                    <strong>efetivos para impulsionar a alfabetização e o aprendizado,</strong>
                                    criando condições para que estudantes com maiores desafios avancem com mais segurança e autonomia em sua
                                    trajetória, ampliando as chances de{' '}
                                    <strong>concluir a educação básica e exercer plenamente a cidadania.</strong>
                                </p>
                            </StyledGlobal.ContentColumn>
                            <StyledGlobal.ContentColumn>
                                <p>
                                    O sucesso dos programas foi potencializado pela{' '}
                                    <strong>distribuição de livros para os(as) estudantes.</strong> Em 2025, foram mais de 8 mil livros
                                    distribuídos, sendo <strong>3.413 livros pedagógicos e 5.500 livros de literatura infanto-juvenil,</strong>{' '}
                                    incluindo exemplares com conteúdo adaptado, garantindo acessibilidade física, visual e cognitiva.
                                </p>
                            </StyledGlobal.ContentColumn>
                        </ResponsiveGrid>
                        <StyledGlobal.CardWhite2 style={{ justifyContent: 'center' }}>
                            <Image
                                style={{ maxWidth: '600px' }}
                                src={fetchStorageFile('anexo_storage_files_4210133479696118963.png_2025-11-21-1763733026907.png')}
                                alt={`
                                    Quadro com quatro ícones de livros indicando o número de exemplares distribuídos por programa e o número de exemplares de livros de literatura. Acelera Brasil: 923 livros; 
                                    Se Liga: 552 livros; Fórmula da Vitória: 1.938; Livros de Literatura: 5.500 livros 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={58} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr',
                        notebook: '1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.CardWhite2 style={{ gap: '40px' }}>
                            <h2 style={{ fontSize: '14px' }}>EXEMPLOS DOS LIVROS DE LITERATURA DISTRIBUÍDOS</h2>
                            <Image
                                width={'100%'}
                                style={{ maxWidth: '600px', objectFit: 'cover' }}
                                src={fetchStorageFile('anexo_storage_files_15940737203314967673.png_2025-11-21-1763733436055.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Um desdobramento concreto da distribuição dos livros é o <strong>aumento da prática leitora</strong> pelos(as)
                            estudantes atendidos pelos programas. No Acelera Brasil, a média de livros lidos por estudante passou de 2,3 para 4,4
                            entre maio e setembro. No Se Liga, o aumento da prática leitora foi similar, saindo de uma média de 1,5 livros e
                            avançando para 3,4, no mesmo período.
                        </p>
                        <StyledGlobal.CardWhite2>
                            <Image
                                style={{ maxWidth: '600px' }}
                                src={fetchStorageFile('anexo_storage_files_11204825881949575409.png_2025-11-21-1763733723314.png')}
                                alt={`
                                    Conjunto de ícones de livros para comparar a média de livros lidos por estudante antes e depois da participação nos programas.  
                                    Acelera Brasil: 
                                    O número de livros lidos aumentou de 2,3 para 4,4 livros por estudante, com seta indicando ‘2 vezes mais’.” 
                                    Se Liga: 
                                    O número de livros lidos aumentou de 1,5 para 3,4 livros por estudante, com seta indicando ‘2 vezes mais’.” 
                                    `}
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                        <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={59} stylesContent={{ marginRight: '80px' }}>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr',
                        notebook: '1fr 1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <p>
                            Além dos efeitos sobre a alfabetização e aumento da proficiência, a prática da leitura, potencializada pelo acesso à
                            um acervo diversificado amplia{' '}
                            <strong>o repertório cultural, contribuindo ainda mais para o desenvolvimento integral dessas crianças.</strong>
                        </p>
                        <p>
                            Integrando as ações do programa <strong>Fórmula da Vitória,</strong> estudantes que apresentavam defasagens de
                            aprendizagem mergulharam no universo da poesia, transformando palavras em pontes para novos saberes. O fruto dessa
                            jornada é um livro de poemas criado nas salas de aula, que será compartilhado com as escolas do município, em uma
                            tiragem de <strong>2 mil exemplares.</strong> Mais do que uma produção pedagógica, o livro expressa a potência
                            criadora dos alunos e a força da escola como espaço de arte, cultura e formação integral.
                        </p>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <StyledGlobal.CardWhite2>
                            <Image
                                src={fetchStorageFile('anexo_storage_files_213475719976066212.png_2025-11-21-1763734011577.png')}
                                alt=""
                                preview={{
                                    style: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                    },
                                }}
                            />
                        </StyledGlobal.CardWhite2>
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Dentro do programa Acelera Brasil, os estudantes participaram de um conjunto de ações que os convidou a explorar e
                            valorizar o patrimônio cultural de sua cidade. Desse percurso nasceu um <strong>curta-metragem</strong> que reúne
                            registros, memórias e aprendizados construídos ao longo das atividades. A experiência permitiu que os alunos se
                            aproximassem de suas raízes e se reconhecessem como parte viva da história local, despertando orgulho e compromisso
                            com a preservação de sua cultura.
                        </p>
                        <p>
                            As soluções implementadas pelo Instituto Ayrton Senna foram avaliadas com nota máxima pela equipe central na
                            Secretaria de Educação, com <strong>100% de satisfação</strong> em todos os aspectos avaliados.
                        </p>
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
                <p style={{ fontSize: '14px' }}>Fonte: Sistema de Monitoramento Instituto Ayrton Senna.</p>
            </PageTemplatePlanoAnual>
            <PageTemplatePlanoAnual numberPage={60} stylesContent={{ marginRight: '80px' }}>
                <StyledGlobal.TitleYellow>HISTÓRIAS DE SUPERAÇÃO</StyledGlobal.TitleYellow>
                <ResponsiveGrid
                    templates={{
                        desktop: '1fr 1fr 1fr',
                        notebook: '1fr 1fr 1fr',
                        tablet: '1fr',
                    }}
                    styles={{ margin: 0, gap: '40px' }}
                >
                    <StyledGlobal.ContentColumn>
                        <Image
                            height={300}
                            style={{ objectFit: 'cover', width: '300px' }}
                            src={fetchStorageFile('anexo_storage_files_6666698065200238634.png_2025-11-21-1763734685090.png')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                        <Quote
                            text={`
                            Eu nunca lia livro
                            direito. Agora eu estou
                            gostando muito de ler!"
                            `}
                        />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <p>
                            Desafios pessoais e sociais impediram que <strong>Sophia</strong>, de 10 anos, e <strong>Allana</strong>, de 12 anos,
                            aprendessem a ler e a escrever na idade adequada. Para superar esses obstáculos e impulsionar suas trajetórias
                            escolares, ambas ingressaram nas turmas do Se Liga em 2025. Em menos de um ano, já sentem as mudanças positivas e
                            vislumbram um futuro melhor.
                        </p>
                        <CardQRcodeVideosPlanoAnual />
                    </StyledGlobal.ContentColumn>
                    <StyledGlobal.ContentColumn>
                        <Image
                            height={300}
                            style={{ objectFit: 'cover', width: '300px', objectPosition: '10% 10%' }}
                            src={fetchStorageFile('anexo_storage_files_8348125710706502003.webp_2025-11-21-1763735130229.webp')}
                            alt=""
                            preview={{
                                style: {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                                },
                            }}
                        />
                        <Quote
                            text={`
                            Quando eu conheci o Se Liga, eu comecei uma
                            nova vida. Saí daquele caminho que eu tava e fui
                            pra outro. Fui aprendendo a ler algumas palavras…"
                            `}
                        />
                    </StyledGlobal.ContentColumn>
                </ResponsiveGrid>
            </PageTemplatePlanoAnual>
        </>
    );
};

export default PageThreeFivePlanoAnual;
